import React from 'react'

export default function PromotionalBanner(props) {
  return (
    <div className='promo-banner'>
        <h3>{props.data.Message}</h3>
    </div>
  )
}
